"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerPointer = exports.ColorPicker = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var ColorPicker_1 = require("./ColorPicker");
Object.defineProperty(exports, "ColorPicker", { enumerable: true, get: function () { return ColorPicker_1.ColorPicker; } });
var ColorPickerPointer_1 = require("./ColorPickerPointer");
Object.defineProperty(exports, "ColorPickerPointer", { enumerable: true, get: function () { return ColorPickerPointer_1.ColorPickerPointer; } });
//# sourceMappingURL=index.js.map